import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import { environment } from '../../../environments/environments';

@Injectable({
  providedIn: 'root'
})
export class PublicEsignService {

  constructor(private readonly http: HttpClient) { }

  getPaymentLink(payload: any) {
    let url = `${environment.API_URL}/v1/transaction/generateLink`;
    return this.http.post(url, payload);
  }

  esignDocument(payload: any) {
    let url = `${environment.API_URL}/v1/public-esign/get-data`;
    return this.http.post(url, payload);
  }

  shareToOthers(payload:any){
    let url = `${environment.API_URL}/v1/public-esign/share`;
    return this.http.post(url,payload);
  }

  getPendingList(page?: number) {
    let url = `${environment.API_URL}/v1/public-esign/pending`;
    if (page !== undefined) {
      url += `?page=${page}`;
    }
    return this.http.get(url);
  }

  getPendingCount() {
    let url = `${environment.API_URL}/v1/public-esign/pending/count`;
    return this.http.get(url);
  }

  exportSharedDocument(id: string) {
    const url = `${environment.API_URL}/v1/public-esign/${id}/export`;
    return this.http.get(url, { responseType: 'blob' });
  }

  submitSharedEsign(payload: { sharedDocumentId: string; signPositions: any[]; esignName: string }) {
    const url = `${environment.API_URL}/v1/public-esign/shared-esign`;
    return this.http.post(url, payload);
  }
}
